import { api } from './api';

export const consumableTrackerService = {
  getStatus: async (type) => {
    try {
      return await api.get(`/api/trackers/${type}/status`);
    } catch (error) {
      console.error(`Error fetching ${type} status:`, error);
      throw error;
    }
  },

  /**
   * Set or update the consumable tracker amount
   * @param {string} type - The tracker type (e.g., 'inhaler', 'nasalSpray', 'eyeDrops')
   * @param {number} [amount] - If provided, sets the tracker to this amount. If undefined, decrements by 1 (use).
   */
  setAmount: async (type, amount) => {
    try {
      if (amount !== undefined) {
        // New tracker set with specific amount
        return await api.post(`/api/trackers/${type}/set-amount`, { amount });
      } else {
        // Decrement by 1 (recorded use)
        return await api.post(`/api/trackers/${type}/set-amount`, {});
      }
    } catch (error) {
      console.error(`Error setting ${type} amount:`, error);
      throw error;
    }
  },
// Fetch the history of uses for a specific tracker type
  getHistory: async (type) => {
    return await api.get(`/api/trackers/${type}/history`);
  }
};